import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 31,
    seconds: 23
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1,
          m = prev.minutes,
          h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <section className="relative pb-3 overflow-hidden flex flex-col items-center text-center" data-id="element-88">
      {/* Green countdown bar */}
      <div className="w-full bg-green-600 py-2 px-4 mb-2" data-id="element-89">
        <div className="flex items-center justify-center gap-2" data-id="element-90">
          <span className="text-white text-sm md:text-base" data-id="element-91">⏱</span>
          <span className="text-white text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-92">
            OFERTA TERMINA EN:
          </span>
          <span className="text-white text-lg md:text-xl font-black tracking-widest tabular-nums" data-id="element-93">
            {fmt(timeLeft.hours)}:{fmt(timeLeft.minutes)}:
            {fmt(timeLeft.seconds)}
          </span>
        </div>
      </div>

      <motion.h1 initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-1 max-w-3xl tracking-tight font-[500] font-['Helvetica Neue', sans-serif]" data-id="element-94">
        Preparación completa para enfrentar el ingreso con más{' '}
        <span className="text-green-500" data-id="element-95">seguridad</span>, más{' '}
        <span className="text-green-500" data-id="element-96">estrategia</span> y más{' '}
        <span className="text-green-500" data-id="element-97">preparación real</span>
      </motion.h1>

      <motion.h2 initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.15
    }} className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black text-brand-gold mb-1 tracking-tight drop-shadow-lg uppercase whitespace-nowrap" data-id="element-98">
        MEGA PACK INGRESO A LAS FUERZAS
      </motion.h2>

      <motion.a href="#pricing" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="block mb-1 relative group cursor-pointer" data-id="element-99">
        <div className="absolute inset-0 bg-brand-gold opacity-0 group-hover:opacity-20 blur-3xl transition-opacity duration-500 rounded-full" data-id="element-100"></div>
        <img src="https://cdn.magicpatterns.com/uploads/p2rkTQzd1bzjqBrjc2PnyU/mockups_ingreso_a_fuerzas_.png" alt="Mega Pack Ingreso a las Fuerzas" className="w-full max-w-xl mx-auto relative z-10 transform transition-transform duration-500 group-hover:scale-105" data-id="element-101" />
      </motion.a>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto mb-2 font-medium leading-snug" data-id="element-102">
        Todo lo que necesitás para prepararte: estudio, psicotécnico,
        entrevista, simulacros y entrenamiento físico, en un solo sistema.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="w-full max-w-md mx-auto mb-2" data-id="element-103">
        <motion.a href="#pricing" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="w-full inline-flex items-center justify-center px-6 py-3 text-lg md:text-xl font-black uppercase tracking-wider rounded-lg transition-all duration-300 shadow-[0 0 20px rgba(34,197,94,0.4)] font-heading bg-green-600 text-white hover:bg-green-500 hover:shadow-[0 0 30px rgba(34,197,94,0.6)]" data-id="element-104">
          → QUIERO ACCEDER AL MEGA PACK
        </motion.a>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.5
    }} className="flex items-center justify-center gap-1" data-id="element-105">
        <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-106">
          📄 100% PDF
        </span>
        <span className="text-gray-600 text-[10px]" data-id="element-107">•</span>
        <span className="text-[10px] font-bold text-brand-blue uppercase tracking-wider" data-id="element-108">
          ⚡ ACCESO INMEDIATO
        </span>
        <span className="text-gray-600 text-[10px]" data-id="element-109">•</span>
        <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-110">
          🇦🇷 FUERZA ARGENTINA
        </span>
      </motion.div>
    </section>;
}